// @ts-nocheck

// Helper: debounce function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

class CheckoutHandler {
  constructor() {
    // Initialize properties - FR only
    this.country = 'FR';
    this.currency = 'EUR';
    this.language = 'FR';
    this.maxCartValue = 6000; // 60€ in cents
    
    // Checkout configuration
    this.sourceId = 'kavinn.co';
    this.logoUrl = 'https://cdn.shopify.com/s/files/1/0998/1683/3361/files/imgi_1_trans-3.png?v=1766317590';
    this.shopColor = '000000';
    this.shopReviews = '3782';
    this.trackingPixel = '';

    // FR tier pricing - all available price points sorted from lowest to highest
    this.tiers = [
      { price: 200 },   // €2.00
      { price: 295 },   // €2.95
      { price: 395 },   // €3.95
      { price: 495 },   // €4.95
      { price: 595 },   // €5.95
      { price: 699 },   // €6.99
      { price: 795 },   // €7.95
      { price: 999 },   // €9.99
      { price: 1190 },  // €11.90
      { price: 1399 },  // €13.99
      { price: 1495 },  // €14.95
      { price: 1795 },  // €17.95
      { price: 1999 },  // €19.99
      { price: 2495 },  // €24.95
      { price: 2995 },  // €29.95
      { price: 3999 },  // €39.99
      { price: 4999 }   // €49.99
    ];

    // Text strings
      this.texts = {
          cartCheckout: 'COMMANDER',
      cartLimitError: 'Le panier est limité à 60€ maximum',
      bundleDiscount: 'Remise Panier'
    };

      this.source = "holls";
      this.fbPixelId = "2380754919061720";
      
    // Set global variables
    window.currentCountry = this.country;
    window.currentCurrency = this.currency;
    window.currentLanguage = this.language;
      
      this.init();
      
    // Add minimal CSS for cart styling
      const style = document.createElement('style');
      style.textContent = `
      /* Cart styling */
        .cart, .cart-drawer, .cart-drawer__content {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
        }
        
      /* Cart summary */
      .cart-summary, .totals, .cart__footer {
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        padding: 1rem;
        margin: 1rem 0;
      }
      
      /* Loading overlay for cart updates */
      .cart-updating-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        backdrop-filter: blur(4px);
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.2s ease;
      }
      
      .cart-updating-overlay.active {
        opacity: 1;
        pointer-events: all;
      }
      
      .cart-loader {
        width: 40px;
        height: 40px;
        border: 3px solid #f3f3f3;
        border-top: 3px solid #E86DAA;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
      }
      
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      
      /* Shimmer effect for updating elements */
      .cart-shimmer {
        position: relative;
        overflow: hidden;
      }
      
      .cart-shimmer::after {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
        animation: shimmer 1.2s infinite;
      }
      
      @keyframes shimmer {
        0% { left: -100%; }
        100% { left: 100%; }
      }
      
      /* Cart error messages - prominent notifications */
      .cart-error-message {
        background: linear-gradient(135deg, #E86DAA, #D65A95);
        border: 2px solid rgba(255, 255, 255, 0.3);
        color: white;
        padding: 1.25rem 2rem;
        border-radius: 12px;
        font-size: 1rem;
        font-weight: 600;
        text-align: center;
        position: fixed;
        top: 30px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10001;
        box-shadow: 0 12px 32px rgba(232, 109, 170, 0.4), 0 4px 12px rgba(0, 0, 0, 0.15);
        animation: errorSlideDown 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
        min-width: 320px;
        max-width: 90vw;
        backdrop-filter: blur(10px);
      }
      
      .cart-error-message::before {
        content: "⚠️ ";
        font-size: 1.2rem;
        margin-right: 0.5rem;
      }
      
      @keyframes errorSlideDown {
        from {
          opacity: 0;
          transform: translateX(-50%) translateY(-30px) scale(0.9);
        }
        to {
          opacity: 1;
          transform: translateX(-50%) translateY(0) scale(1);
        }
      }
      
      @keyframes errorSlideUp {
        from {
          opacity: 1;
          transform: translateX(-50%) translateY(0) scale(1);
        }
        to {
          opacity: 0;
          transform: translateX(-50%) translateY(-30px) scale(0.9);
        }
      }
      
      /* Success message for cart updates */
      .cart-success-message {
        background: linear-gradient(135deg, #22c55e, #16a34a);
        border: 2px solid rgba(255, 255, 255, 0.3);
        color: white;
        padding: 1rem 1.5rem;
        border-radius: 12px;
        font-size: 0.95rem;
        font-weight: 600;
        text-align: center;
        position: fixed;
        top: 30px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10001;
        box-shadow: 0 12px 32px rgba(34, 197, 94, 0.3);
        animation: errorSlideDown 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
        min-width: 280px;
        max-width: 90vw;
      }
      
      .cart-success-message::before {
        content: "✓ ";
        font-size: 1.2rem;
        margin-right: 0.5rem;
      }
      
      /* Cart checkout button */
        .cart__checkout-button {
          background: #000 !important;
          color: #fff !important;
          border: none !important;
          padding: 1rem 2rem !important;
          font-size: 1.1rem !important;
          font-weight: 600 !important;
        border-radius: 4px !important;
          cursor: pointer !important;
        width: 100% !important;
        }
        
        .cart__checkout-button:hover {
          background: #333 !important;
        }
        
        .cart__checkout-button:disabled {
          background: #ccc !important;
          cursor: not-allowed !important;
        }
      `;
      document.head.appendChild(style);
    
    console.log('✅ CheckoutHandler initialized (FR only)');
  }
  
  // Get cookie value (from pixel.js logic)
  getCookieValue(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }
  
  // Get custom domain pixel from cookies
  getCustomDomainPixel() {
    const subdomainPixel = this.getCookieValue("sdp");
    const baseDomain = this.getCookieValue("domain");
    return subdomainPixel && baseDomain ? `${subdomainPixel}.${baseDomain}` : '';
  }

  init() {
    this.setupLoadingOverlay();
    this.setupCartValidation();
    this.setupCartCheckoutRedirection();
    this.updateCartDisplay();
  }
  
  // Setup loading overlay in cart
  setupLoadingOverlay() {
    // Create loading overlay if it doesn't exist
    const createOverlay = () => {
      const existing = document.querySelector('.cart-updating-overlay');
      if (existing) return existing;
      
      const overlay = document.createElement('div');
      overlay.className = 'cart-updating-overlay';
      overlay.innerHTML = '<div class="cart-loader"></div>';
      return overlay;
    };
    
    // Store reference
    this.loadingOverlay = createOverlay();
  }
  
  // Show loading state
  showLoading() {
    const cartSummary = document.querySelector('.cart-drawer-v2__summary, .cart-summary-v2, .cart-drawer__summary, .cart__summary-totals, .cart-summary');
    if (!cartSummary) return;
    
    // Ensure overlay exists and is attached
    if (!this.loadingOverlay.parentNode) {
      cartSummary.style.position = 'relative';
      cartSummary.appendChild(this.loadingOverlay);
    }
    
    // Show overlay
    this.loadingOverlay.classList.add('active');
    
    // Add shimmer to elements
    const bundleDiscount = document.querySelector('[data-bundle-discount]');
    const checkoutButton = document.querySelector('.cart-summary-v2__checkout-button, .cart__checkout-button');
    
    if (bundleDiscount) bundleDiscount.classList.add('cart-shimmer');
    if (checkoutButton) checkoutButton.classList.add('cart-shimmer');
  }
  
  // Hide loading state
  hideLoading() {
    if (this.loadingOverlay) {
      this.loadingOverlay.classList.remove('active');
    }
    
    // Remove shimmer
    document.querySelectorAll('.cart-shimmer').forEach(el => {
      el.classList.remove('cart-shimmer');
    });
  }

  // Setup cart validation for 60€ limit
  setupCartValidation() {
    // Intercept cart additions
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (form.matches('[action="/cart/add"]')) {
        e.preventDefault();
        e.stopPropagation();
        
        try {
          const formData = new FormData(form);
          const variantId = formData.get('id');
          const quantity = parseInt(formData.get('quantity') || '1');
          
          // Check if adding this item would exceed limit
          const canAdd = await this.validateCartAddition(variantId, quantity);
          
          if (canAdd) {
            // Proceed with adding to cart
            await this.addToCart(formData);
          } else {
            this.showError(this.texts.cartLimitError);
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
        }
      }
    });

    // Monitor cart quantity changes
    document.addEventListener('change', async (e) => {
      const input = e.target;
      if (input.matches('input[name*="updates"]')) {
        const newQuantity = parseInt(input.value);
        const lineKey = input.name.match(/updates\[([^\]]+)\]/)?.[1];
        
        if (lineKey && newQuantity > 0) {
          const canUpdate = await this.validateCartUpdate(lineKey, newQuantity);
          
          if (!canUpdate) {
            this.showError(this.texts.cartLimitError);
            // Revert to previous value
            const cart = await this.getCart();
            const item = cart.items.find(i => i.key === lineKey);
            if (item) {
              input.value = item.quantity;
            }
            e.preventDefault();
          } else {
            // Quantity change is valid, wait for cart to update then refresh display
            console.log('📊 Quantity change valid, updating display...');
            setTimeout(() => {
              this.updateCartDisplay();
              document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'quantity' } }));
            }, 200);
          }
        }
      }
    });
    
    // Also listen for input events on quantity fields (for manual typing)
    document.addEventListener('input', debounce((e) => {
      const input = e.target;
      if (input.matches('input[name*="updates"]') || input.matches('input[type="number"]')) {
        console.log('📝 Quantity input detected');
        setTimeout(() => {
          this.updateCartDisplay();
        }, 200);
      }
    }, 300));
    
    // Monitor cart item removals
    document.addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('.cart-items__remove, [data-cart-item-remove]');
      if (removeBtn) {
        console.log('🗑️ Item removal detected');
        // Show loading immediately
        this.showLoading();
        // Wait for removal to complete then refresh
        setTimeout(() => {
          this.updateCartDisplay();
          // Dispatch custom event
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'remove' } }));
        }, 300);
      }
    });
    
    // Monitor for cart form submissions (direct cart updates)
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form.matches('[action="/cart"]') || form.matches('#cart-form')) {
        console.log('🔄 Cart form submitted');
        this.showLoading();
        setTimeout(() => {
          this.updateCartDisplay();
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'update' } }));
        }, 250);
      }
    });

    console.log('✅ Cart validation setup (60€ limit)');
  }

  // Validate if adding item would exceed 60€
  async validateCartAddition(variantId, quantity) {
    try {
      const cart = await this.getCart();
      const product = await this.getVariantInfo(variantId);
      
      if (!product) return false;
      
      // Calculate current cart total (original prices)
      let currentTotal = 0;
      for (const item of cart.items) {
        const itemProduct = await this.getProductByHandle(item.handle);
        const variant = itemProduct?.variants.find(v => v.id === item.variant_id);
        if (variant) {
          const price = this.getOriginalPrice(variant);
          currentTotal += price * item.quantity;
        }
      }
      
      // Add new item
      const newItemPrice = this.getOriginalPrice(product);
      const newTotal = currentTotal + (newItemPrice * quantity);
      
      return newTotal <= this.maxCartValue;
    } catch (error) {
      console.error('Error validating cart addition:', error);
      return false;
    }
  }

  // Validate if updating quantity would exceed 60€
  async validateCartUpdate(lineKey, newQuantity) {
    try {
      const cart = await this.getCart();
      
      // Calculate total with new quantity
      let total = 0;
      for (const item of cart.items) {
        const itemProduct = await this.getProductByHandle(item.handle);
        const variant = itemProduct?.variants.find(v => v.id === item.variant_id);
        if (variant) {
          const price = this.getOriginalPrice(variant);
          const qty = item.key === lineKey ? newQuantity : item.quantity;
          total += price * qty;
        }
      }
      
      return total <= this.maxCartValue;
      } catch (error) {
      console.error('Error validating cart update:', error);
      return false;
    }
  }

  // Add item to cart
  async addToCart(formData) {
    try {
      // Show loading immediately
      this.showLoading();
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('✅ Product added to cart:', result);
        
        // Fetch updated cart for analytics
        const cartResponse = await fetch('/cart.js');
        const cart = cartResponse.ok ? await cartResponse.json() : null;
        
        // Track add to cart event for Shopify Analytics
        if (cart) {
          this.trackAddToCart(result, cart);
        }
        
        // Show success message
        this.showSuccess('Produit ajouté au panier');
        
        // Dispatch both standard and custom events
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'add' } }));
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'add', item: result } }));
        
        // Open cart drawer immediately
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        
        // Update display quickly
        setTimeout(() => {
          this.updateCartDisplay();
        }, 100);
      } else {
        this.hideLoading();
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      this.hideLoading();
      console.error('Error adding to cart:', error);
      throw error;
    }
  }

  // Get cart data
  async getCart() {
    const response = await fetch('/cart.json');
    return await response.json();
  }

  // Get variant info
  async getVariantInfo(variantId) {
    try {
      // Try to get from cart first
      const cart = await this.getCart();
      const cartItem = cart.items.find(i => i.variant_id.toString() === variantId.toString());
      
      if (cartItem) {
        const product = await this.getProductByHandle(cartItem.handle);
        return product?.variants.find(v => v.id.toString() === variantId.toString());
      }
      
      return null;
    } catch (error) {
      console.error('Error getting variant info:', error);
      return null;
    }
  }

  // Get product by handle
  async getProductByHandle(handle) {
    try {
        const response = await fetch(`/products/${handle}.json`);
        const data = await response.json();
      return data.product;
      } catch (error) {
      console.error('Error fetching product:', error);
      return null;
    }
  }

  // Get original price for a variant (use actual selling price, not compare_at)
  getOriginalPrice(variant) {
    // Use the actual price the customer pays
    let price = variant.price;
    
    // Ensure price is in cents
    if (price < 100) {
      price = Math.round(price * 100);
    }
    
    return price;
  }

  // Calculate tier for total amount (round DOWN to highest tier <= total)
  calculateBottomTier(totalAmount) {
    // Find the highest tier price that's <= the cart total (includes equal)
    let selectedTier = this.tiers[0]; // Default to lowest tier (€1.95)
    
    for (const tier of this.tiers) {
      if (tier.price <= totalAmount) {
        selectedTier = tier;
      } else {
        // Stop when we reach a tier that's > total
        break;
      }
    }
    
    console.log(`💰 Cart total: ${this.formatPrice(totalAmount)} → Rounded to: ${this.formatPrice(selectedTier.price)}`);
    
    return selectedTier;
  }

  // Calculate cart totals with bundle discount
  async calculateCartTotals() {
    try {
      const cart = await this.getCart();
      
      if (cart.item_count === 0) {
        return {
          originalTotal: 0,
          tierTotal: 0,
          discount: 0
        };
      }
      
      // Calculate original total
      let originalTotal = 0;
      for (const item of cart.items) {
        const product = await this.getProductByHandle(item.handle);
        const variant = product?.variants.find(v => v.id === item.variant_id);
        if (variant) {
          const price = this.getOriginalPrice(variant);
          originalTotal += price * item.quantity;
        }
      }
      
      // Find bottom tier
      const tier = this.calculateBottomTier(originalTotal);
      const tierTotal = tier.price;
      const discount = originalTotal - tierTotal;
      
      return {
        originalTotal,
        tierTotal,
        discount: discount > 0 ? discount : 0
      };
       } catch (error) {
      console.error('Error calculating cart totals:', error);
      return {
        originalTotal: 0,
        tierTotal: 0,
        discount: 0
      };
    }
  }

  // Update cart display with bundle discount
  async updateCartDisplay() {
    try {
      // Show loading immediately
      this.showLoading();
      
      const totals = await this.calculateCartTotals();
      
      console.log('🔄 Updating cart display:', totals);
      
      if (totals.tierTotal === 0) {
        console.log('⚠️ Cart is empty, skipping update');
        this.hideLoading();
        return;
      }
      
      // Update cart summary
      this.updateCartSummary(totals);
      
      // Update checkout button
      this.updateCheckoutButton(totals);
      
      // Hide loading after a brief delay to avoid flashing
      setTimeout(() => {
        this.hideLoading();
      }, 100);
      
    } catch (error) {
      console.error('❌ Error updating cart display:', error);
      this.hideLoading();
    }
  }

  // Update cart summary with bundle discount
  updateCartSummary(totals) {
    // Find the bundle discount container from Liquid template
    const bundleContainer = document.querySelector('[data-bundle-discount]');
    
    if (!bundleContainer) {
      console.warn('⚠️ Could not find bundle discount container');
      return;
    }
    
    // Show/hide discount based on whether there is one
    if (totals.discount > 0) {
      // Calculate percentage
      const percentage = Math.round((totals.discount / totals.originalTotal) * 100);
      
      // Update all the values
      const discountAmount = bundleContainer.querySelector('[data-discount-amount]');
      const originalTotal = bundleContainer.querySelector('[data-original-total]');
      const discountDisplay = bundleContainer.querySelector('[data-discount-display]');
      
      if (discountAmount) discountAmount.textContent = `-${this.formatPrice(totals.discount)}`;
      if (originalTotal) originalTotal.textContent = this.formatPrice(totals.originalTotal);
      
      // Add discount to display
      if (discountDisplay) {
        discountDisplay.textContent = `-${this.formatPrice(totals.discount)}`;
      }
      
      // Always show the container
      bundleContainer.style.display = 'block';
      
      console.log(`🎉 Liquidation de fin d'année discount displayed: -${this.formatPrice(totals.discount)}`);
    } else {
      // Hide if no discount
      bundleContainer.style.display = 'none';
    }
    
    // Update all total displays to show tier price
    this.updateTotalDisplays(totals);
    
    console.log(`✅ Cart updated: ${this.formatPrice(totals.originalTotal)} → ${this.formatPrice(totals.tierTotal)} (discount: ${this.formatPrice(totals.discount)})`);
  }

  // Update total price displays
  updateTotalDisplays(totals) {
    // Update v2 cart total
    const totalValueV2 = document.querySelector('.cart-summary-v2__total-value, [data-cart-total]');
    if (totalValueV2) {
      totalValueV2.textContent = this.formatPrice(totals.tierTotal);
    }
    
    // Target the main "Total estimé" display if it exists (legacy)
    const totalEstimatedLabel = Array.from(document.querySelectorAll('*')).find(el => 
      el.textContent.trim().startsWith('Total estimé') || el.textContent.trim().startsWith('Total')
    );
    
    if (totalEstimatedLabel && totalEstimatedLabel.parentElement) {
      const container = totalEstimatedLabel.parentElement;
      
      // Look for the price element in the same container
      const priceElements = container.querySelectorAll('.price, [data-cart-total], [data-cart-subtotal]');
      priceElements.forEach(priceEl => {
        priceEl.textContent = this.formatPrice(totals.tierTotal);
      });
    }
    
    // Also update data attributes directly
    const dataElements = document.querySelectorAll('[data-cart-total], [data-cart-subtotal]');
    dataElements.forEach(element => {
      element.textContent = this.formatPrice(totals.tierTotal);
    });
    
    console.log(`💰 Updated displays to show: ${this.formatPrice(totals.tierTotal)}`);
  }

  // Update checkout button with price
  updateCheckoutButton(totals) {
    const checkoutBtn = document.querySelector('#checkout, .cart-summary-v2__checkout-button, .cart__checkout-button');
    if (!checkoutBtn) return;
    
    // Check if it's a v2 button
    const isV2 = checkoutBtn.classList.contains('cart-summary-v2__checkout-button');
    
    if (isV2) {
      // V2 button - keep static content (lock icon + text already in Liquid)
      // Don't update innerHTML to preserve the lock icon
      console.log('✅ V2 button - keeping static content with lock icon');
    } else {
      // Legacy button
      checkoutBtn.innerHTML = `
        <span>${this.texts.cartCheckout} - ${this.formatPrice(totals.tierTotal)}</span>
      `;
    }
  }

  // Setup checkout button redirection
    setupCartCheckoutRedirection() {
      document.addEventListener('click', async (e) => {
        const checkoutBtn = e.target.closest('#checkout, .cart-summary-v2__checkout-button, .cart__checkout-button');
        if (!checkoutBtn) return;
        
          e.preventDefault();
          e.stopPropagation();
        
        try {
        const cart = await this.getCart();
          
        if (cart.item_count === 0) {
            console.log('🛒 Cart is empty');
            return;
          }
          
        const totals = await this.calculateCartTotals();
        
        // Trigger Shopify Analytics "reached_checkout" event
        this.trackReachedCheckout(cart, totals);
        
        // Build checkout URL
        const checkoutUrl = this.buildCheckoutUrl(totals, cart);
        
        // Redirect to checkout (logs are preserved in buildCheckoutUrl)
        console.log('🚀 Redirecting to checkout:', checkoutUrl);
        window.location.href = checkoutUrl;
          
        } catch (error) {
          console.error('Error during checkout:', error);
        this.showError('⚠️ Erreur de commande. Veuillez réessayer.');
      }
    });
  }

  // Track "add_to_cart" event for Shopify Analytics
  trackAddToCart(result, cart) {
    try {
      // Get the added item details
      const addedItem = cart.items.find(item => item.variant_id === result.variant_id) || result;
      
      // Method 1: Shopify Analytics API (modern method)
      if (typeof Shopify !== 'undefined' && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('add_to_cart', {
          cartToken: cart.token,
          productId: addedItem.product_id,
          variantId: addedItem.variant_id,
          quantity: addedItem.quantity || result.quantity || 1,
          price: (addedItem.final_price || addedItem.price || 0) / 100,
          currency: 'EUR',
          productTitle: addedItem.product_title || result.product_title || '',
          variantTitle: addedItem.variant_title || result.variant_title || ''
        });
        console.log('✅ Shopify Analytics: add_to_cart event published');
        return;
      }

      // Method 2: Legacy analytics tracking
      if (typeof Shopify !== 'undefined' && Shopify.analytics && Shopify.analytics.track) {
        Shopify.analytics.track('add_to_cart', {
          cartToken: cart.token,
          productId: addedItem.product_id,
          variantId: addedItem.variant_id,
          quantity: addedItem.quantity || result.quantity || 1,
          price: (addedItem.final_price || addedItem.price || 0) / 100
        });
        console.log('✅ Shopify Analytics: add_to_cart event tracked (legacy)');
        return;
      }

      // Method 3: Custom event for analytics listeners
      document.dispatchEvent(new CustomEvent('shopify:analytics:add_to_cart', {
        bubbles: true,
        detail: {
          cartToken: cart.token,
          productId: addedItem.product_id,
          variantId: addedItem.variant_id,
          quantity: addedItem.quantity || result.quantity || 1,
          price: (addedItem.final_price || addedItem.price || 0) / 100,
          currency: 'EUR'
        }
      }));
      console.log('✅ Custom analytics event: shopify:analytics:add_to_cart dispatched');

      // Method 4: DataLayer for Google Analytics / other trackers
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'EUR',
            value: (addedItem.final_price || addedItem.price || 0) / 100,
            items: [{
              item_id: addedItem.variant_id,
              item_name: addedItem.product_title || result.product_title || '',
              item_variant: addedItem.variant_title || result.variant_title || '',
              price: (addedItem.final_price || addedItem.price || 0) / 100,
              quantity: addedItem.quantity || result.quantity || 1
            }]
          }
        });
        console.log('✅ DataLayer: add_to_cart event pushed');
      }

    } catch (error) {
      console.warn('⚠️ Error tracking add_to_cart event:', error);
    }
  }

  // Track "reached_checkout" event for Shopify Analytics
  trackReachedCheckout(cart, totals) {
    try {
      // Method 1: Shopify Analytics API (modern method)
      if (typeof Shopify !== 'undefined' && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('reached_checkout', {
          cartToken: cart.token,
          totalPrice: totals.tierTotal / 100, // Convert to euros
          currency: 'EUR',
          items: cart.items.map(item => ({
            productId: item.product_id,
            variantId: item.variant_id,
            quantity: item.quantity,
            price: item.final_price / 100,
            title: item.product_title,
            variantTitle: item.variant_title || ''
          }))
        });
        console.log('✅ Shopify Analytics: reached_checkout event published');
        return;
      }

      // Method 2: Legacy analytics tracking
      if (typeof Shopify !== 'undefined' && Shopify.analytics && Shopify.analytics.track) {
        Shopify.analytics.track('reached_checkout', {
          cartToken: cart.token,
          totalPrice: totals.tierTotal / 100,
          currency: 'EUR'
        });
        console.log('✅ Shopify Analytics: reached_checkout event tracked (legacy)');
        return;
      }

      // Method 3: Custom event for analytics listeners
      document.dispatchEvent(new CustomEvent('shopify:analytics:reached_checkout', {
        bubbles: true,
        detail: {
          cartToken: cart.token,
          totalPrice: totals.tierTotal / 100,
          currency: 'EUR',
          items: cart.items
        }
      }));
      console.log('✅ Custom analytics event: shopify:analytics:reached_checkout dispatched');

      // Method 4: DataLayer for Google Analytics / other trackers
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'reached_checkout',
          ecommerce: {
            checkout: {
              actionField: {
                step: 1
              },
              products: cart.items.map(item => ({
                id: item.variant_id,
                name: item.product_title,
                variant: item.variant_title || '',
                price: item.final_price / 100,
                quantity: item.quantity
              }))
            },
            currency: 'EUR',
            value: totals.tierTotal / 100
          }
        });
        console.log('✅ DataLayer: reached_checkout event pushed');
      }

    } catch (error) {
      console.warn('⚠️ Error tracking reached_checkout event:', error);
    }
  }

  // Build checkout URL
  buildCheckoutUrl(totals, cart) {
    // Get first item for variant ID
    const firstItem = cart.items[0];
    const variantId = firstItem.variant_id || '';
    
    // Convert prices to euros
    const productPrice = (totals.tierTotal / 100).toFixed(2); // Tier-rounded price
    const productOriginalPrice = (totals.originalTotal / 100).toFixed(2); // Original cart total
    
    // Get custom domain pixel from cookies
    const customDomainPixel = this.getCustomDomainPixel();
    
    // Product info (using first product's image)
    const productName = 'Total';
    const productImage = 'https://cdn.shopify.com/s/files/1/0998/1683/3361/files/kavinn.de-favicon-128.jpg?v=1766325147';
    const productTags = '';
    
    // Build the checkout URL
    const checkoutUrl = `https://checkout.${this.sourceId}/c/checkout?` +
      `sn=${encodeURIComponent(this.sourceId)}` +
      `&p_name=${encodeURIComponent(productName)}` +
      `&p_image=${encodeURIComponent(productImage)}` +
      `&p_cprice=${productPrice}` +
      `&p_oprice=${productOriginalPrice}` +
      `&currency=${this.currency}` +
      `&logo=${encodeURIComponent(this.logoUrl)}` +
      `&color=${encodeURIComponent(this.shopColor)}` +
      `&reviews=${encodeURIComponent(this.shopReviews)}` +
      `&tags=${encodeURIComponent(productTags)}` +
      `&variant_id=${variantId}` +
      `&fb=1570854460740594` +
      `&tt=` +
      `&cdp=${encodeURIComponent(customDomainPixel)}` +
      `&tp=${encodeURIComponent(this.trackingPixel)}`;
    
    console.log(`🔗 Building checkout URL: ${this.formatPrice(totals.tierTotal)} (${productPrice}€)`);
    console.log(`📊 Full Checkout URL:`, checkoutUrl);
    console.log(`\n📋 URL Parameters:`);
    console.log(`  - Source: ${this.sourceId}`);
    console.log(`  - Current Price (p_cprice): ${productPrice}€`);
    console.log(`  - Original Price (p_oprice): ${productOriginalPrice}€`);
    console.log(`  - Discount: ${(productOriginalPrice - productPrice).toFixed(2)}€`);
    console.log(`  - Variant ID: ${variantId}`);
    console.log(`  - Custom Domain Pixel: ${customDomainPixel || 'none'}`);
    console.log(`  - Tracking Pixel: ${this.trackingPixel}`);
    
    return checkoutUrl;
  }

  // Format price for display
  formatPrice(priceInCents) {
    const price = priceInCents / 100;
    return `${price.toFixed(2).replace('.', ',')}€`;
  }

  // Show error message
  showError(message) {
    // Remove existing messages
    document.querySelectorAll('.cart-error-message, .cart-success-message').forEach(el => el.remove());
    
    // Create error message
        const errorDiv = document.createElement('div');
    errorDiv.className = 'cart-error-message';
    errorDiv.innerHTML = `<span>${message}</span>`;
        document.body.appendChild(errorDiv);
        
    console.log('❌ Error shown:', message);
    
    // Auto-hide after 4 seconds
        setTimeout(() => {
      errorDiv.style.animation = 'errorSlideUp 0.4s ease-out forwards';
          setTimeout(() => {
            if (errorDiv.parentNode) {
              errorDiv.remove();
            }
          }, 400);
        }, 4000);
  }
  
  // Show success message
  showSuccess(message) {
    // Remove existing messages
    document.querySelectorAll('.cart-error-message, .cart-success-message').forEach(el => el.remove());
    
    // Create success message
    const successDiv = document.createElement('div');
    successDiv.className = 'cart-success-message';
    successDiv.innerHTML = `<span>${message}</span>`;
    document.body.appendChild(successDiv);
    
    console.log('✅ Success shown:', message);
    
    // Auto-hide after 2.5 seconds
    setTimeout(() => {
      successDiv.style.animation = 'errorSlideUp 0.4s ease-out forwards';
      setTimeout(() => {
        if (successDiv.parentNode) {
          successDiv.remove();
        }
      }, 400);
    }, 2500);
    }
  }
  
// Initialize the checkout handler
function initializeCheckoutHandler() {
  if (window.checkoutHandler) {
    console.log('🔄 Checkout handler already exists');
    return;
  }
  
  window.checkoutHandler = new CheckoutHandler();
  console.log('✅ Checkout handler initialized (FR only, 60€ limit)');
  
  // Debounce function for cart updates
  let updateTimeout = null;
  const debouncedUpdate = () => {
    if (updateTimeout) clearTimeout(updateTimeout);
    updateTimeout = setTimeout(() => {
      if (window.checkoutHandler) {
        window.checkoutHandler.updateCartDisplay();
      }
    }, 100);
  };
  
  // Handle cart updates (Shopify theme events)
  document.addEventListener('cart:updated', (e) => {
    console.log('🔄 Cart updated event:', e.detail);
    debouncedUpdate();
  });
  
  // Handle section reloads
  document.addEventListener('shopify:section:load', () => {
    console.log('🔄 Section loaded, refreshing display...');
    debouncedUpdate();
  });
  
  // Listen for custom cart change events (from cart API)
  document.addEventListener('cart:change', () => {
    console.log('🔄 Cart change detected');
    debouncedUpdate();
  });
  
  // Listen for Shopify theme cart events
  if (typeof Shopify !== 'undefined' && Shopify.theme) {
    document.addEventListener('theme:cart:change', () => {
      console.log('🔄 Theme cart change detected');
      debouncedUpdate();
    });
  }
  
  // Watch for cart drawer opening and DOM changes
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    
    for (const mutation of mutations) {
      // Check if cart drawer opened
      if (mutation.type === 'attributes') {
        const target = mutation.target;
        if (target.matches && (target.matches('cart-drawer') || target.matches('cart-drawer-component') || target.matches('.cart-drawer') || target.matches('.cart-drawer-v2') || target.matches('[data-cart-drawer]'))) {
          if (target.classList.contains('active') || target.hasAttribute('open') || target.open) {
            console.log('🔄 Cart drawer opened');
            shouldUpdate = true;
            break;
          }
        }
      }
      
      // Check if cart content changed
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasCartContent = addedNodes.some(node => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches && (
            node.matches('.cart-items') ||
            node.matches('[data-bundle-discount]') ||
            node.matches('.cart__summary-totals') ||
            node.querySelector('.cart-items, [data-bundle-discount], .cart__summary-totals')
          );
        });
        
        if (hasCartContent) {
          console.log('🔄 Cart content changed');
          shouldUpdate = true;
          break;
        }
      }
    }
    
    if (shouldUpdate) {
      debouncedUpdate();
    }
  });
  
  // Observe the document for cart-related changes
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'open'],
    childList: true,
    subtree: true
  });
  
  // Initial cart check
  setTimeout(() => {
    const cartDrawer = document.querySelector('cart-drawer, cart-drawer-component, .cart-drawer, .cart-drawer-v2');
    if (cartDrawer && window.checkoutHandler) {
      console.log('🔄 Initial cart check...');
      window.checkoutHandler.updateCartDisplay();
    }
  }, 200);
  
  // Store observer for cleanup
  window.checkoutHandler.domObserver = observer;
  
  // Periodic check to ensure cart stays synchronized (fallback)
  let lastCartState = null;
  const periodicCheck = setInterval(async () => {
    // Only check if cart drawer is visible
    const cartDrawer = document.querySelector('cart-drawer, cart-drawer-component, .cart-drawer, .cart-drawer-v2');
    if (!cartDrawer) return;
    
    const isOpen = cartDrawer.classList.contains('active') || 
                   cartDrawer.hasAttribute('open') || 
                   cartDrawer.open ||
                   (cartDrawer.querySelector && cartDrawer.querySelector('[open]'));
    
    if (!isOpen) return;
    
    try {
      const cart = await fetch('/cart.json').then(r => r.json());
      const currentState = JSON.stringify({
        count: cart.item_count,
        total: cart.total_price,
        items: cart.items.map(i => ({ id: i.id, qty: i.quantity }))
      });
      
      if (lastCartState && lastCartState !== currentState) {
        console.log('🔄 Periodic check detected cart change');
        debouncedUpdate();
      }
      
      lastCartState = currentState;
    } catch (error) {
      console.error('Periodic check error:', error);
    }
  }, 1500); // Check every 1.5 seconds when cart is open
  
  // Store interval for cleanup
  window.checkoutHandler.periodicCheckInterval = periodicCheck;
}
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCheckoutHandler);
  } else {
    initializeCheckoutHandler();
  }
  
// Also initialize on page show (for back/forward navigation)
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    console.log('🔄 Page restored from cache, reinitializing...');
    setTimeout(initializeCheckoutHandler, 100);
  }
});

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
  if (window.checkoutHandler) {
    if (window.checkoutHandler.domObserver) {
      window.checkoutHandler.domObserver.disconnect();
    }
    if (window.checkoutHandler.periodicCheckInterval) {
      clearInterval(window.checkoutHandler.periodicCheckInterval);
    }
    console.log('✅ CheckoutHandler cleanup complete');
  }
});
